const PKCE_CODE_VERIFIER_KEY = 'pkce_code_verifier';

const base64UrlEncode = (buffer: Uint8Array): string =>
  btoa(String.fromCharCode(...buffer))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

export class PkceUtils {
  static generateCodeVerifier = (): string => {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return base64UrlEncode(array);
  };

  static generateCodeChallenge = async (codeVerifier: string): Promise<string> => {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
    return base64UrlEncode(new Uint8Array(digest));
  };

  static storeCodeVerifier = (codeVerifier: string) => sessionStorage.setItem(PKCE_CODE_VERIFIER_KEY, codeVerifier);

  static getCodeVerifier = (): string | null => sessionStorage.getItem(PKCE_CODE_VERIFIER_KEY);

  static clearCodeVerifier = () => sessionStorage.removeItem(PKCE_CODE_VERIFIER_KEY);
}
